<template>
  <div id="app">
    <component
      :is="getLayoutComponent"
      :layoutProps="getLayoutProps"
      :subLayoutData="getChildLayoutData"
    >
      <div v-if="coverLoading" class="loading-container cover">
        <div class="loading">
          <lottie
            :options="{ animationData: LoadingAnimation }"
            :width="32"
            :height="32"
          />
        </div>
      </div>
      <router-view/>
    </component>
    <div class="notifications">
      <transition-group name="fade-up">
        <Notification
          v-for="notification in notifications"
          :key="notification.timestamp"
          :notification="notification"
        />
      </transition-group>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex"
import Lottie from "vue-lottie"

import BlankLayout from "@/layouts/BlankLayout.vue"
import Notification from "@/components/ui/Notification.vue"

import LoadingAnimation from "@/assets/animations/ui/loading.json"

export default {
  name: "App",
  metaInfo () {
    const title = "ProGuides - Learn from the Best"
    return {
      title,
      meta: [{ vmid: "title", name: "title", content: title }],
    }
  },
  components: {
    BlankLayout,
    Lottie,
    Notification,
  },
  data: function () {
    return {
      LoadingAnimation,
    }
  },
  computed: {
    ...mapGetters("User", ["getUser"]),
    ...mapGetters("Util", ["coverLoading", "isPageStatic"]),
    ...mapGetters("Notification", ["notifications"]),
    getLayoutComponent () {
      return this.getLayoutData().component || BlankLayout
    },
    getLayoutProps () {
      return this.getLayoutData().props
    },
    getChildLayoutData () {
      return this.getLayoutData().child
    },
  },
  methods: {
    ...mapActions("Util", ["appendKlaviyo"]),
    ...mapActions("User", ["loadUser"]),
    ...mapActions("Pusher", ["initCoachPusher", "listenInventoryUpdate"]),
    getLayoutData () {
      // Use top level layout data for matched route
      let topLevelRouteData = this.$route.matched[0] || {}
      return this.$_.get(topLevelRouteData, "meta.layout") || {}
    },
    async initUserEventListeners () {
      await this.initCoachPusher()
      this.listenInventoryUpdate()
    },
  },
  async mounted () {
    if (this.isPageStatic(window.location.pathname)) return
    const user = await this.loadUser()

    if (user) {
      const { id, ...userProperties } = user
      this.trackAnalyticsIdentity(id, { ...userProperties })
      // id set for /guides page (wordpress app) identity calls
      window.localStorage.setItem("user_id", id)
    }

    this.appendKlaviyo()
    this.initUserEventListeners()
  },
  watch: {
    async getUser (val, oldVal) {
      if (val && val.id !== oldVal?.id) {
        this.initUserEventListeners()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/style/_mixins.scss";
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  display: flex;
  flex-direction: column;
  flex: 1 0 auto;
  min-height: 100vh;
  .notifications {
    position: fixed;
    bottom: 2rem;
    left: 2rem;
    z-index: 101;
  }
}
.loading-container {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: #fff;
  z-index: 100;
  &.cover {
    opacity: 0.9;
  }
  .loading {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}

.fade-up-enter-active {
  transition: all 0.5s ease;
}
.fade-up-leave-active {
  transition: all 0.5s ease;
}
.fade-up-enter {
  transform: translateY(10px);
  opacity: 0;
}
.fade-up-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue